import React, { useEffect, useState } from 'react';

const inputClass = "w-full rounded-lg bg-[#09090b] border border-[#3f3f46] px-3 py-2 text-sm text-white placeholder:text-zinc-500 focus:outline-none focus:ring-2 focus:ring-blue-500";

export default function FormRenderer({ template, onSubmit }) {
  const [values, setValues] = useState({});

  useEffect(() => {
    const defaults = {};
    (template?.fields || []).forEach((field) => {
      if (field.default_value !== undefined && field.default_value !== null && field.default_value !== '') {
        defaults[field.id] = field.default_value;
      }
    });
    setValues(defaults);
  }, [template]);

  const setValue = (id, value) => {
    setValues(prev => ({ ...prev, [id]: value }));
  };

  const submit = (e) => {
    e.preventDefault();
    onSubmit?.(values);
  };

  const fields = template?.fields || [];

  return (
    <form onSubmit={submit} className="space-y-4">
      {fields.map((field) => (
        <div key={field.id} className={field.width === 'half' ? 'md:col-span-1' : 'md:col-span-2'}>
          <label className="block text-sm font-medium text-zinc-200 mb-1">
            {field.label}
            {field.required ? <span className="text-red-400 ml-1">*</span> : null}
          </label>

          {['text','short_text'].includes(field.type) && (
            <input
              className={inputClass}
              required={field.required}
              placeholder={field.placeholder || ''}
              value={values[field.id] || ''}
              onChange={(e) => setValue(field.id, e.target.value)}
            />
          )}

          {['textarea','long_text'].includes(field.type) && (
            <textarea
              className={`${inputClass} min-h-[110px]`}
              required={field.required}
              placeholder={field.placeholder || ''}
              value={values[field.id] || ''}
              onChange={(e) => setValue(field.id, e.target.value)}
            />
          )}

          {field.type === 'number' && (
            <input
              type="number"
              className={inputClass}
              required={field.required}
              value={values[field.id] || ''}
              onChange={(e) => setValue(field.id, e.target.value)}
            />
          )}

          {field.type === 'date' && (
            <input
              type="date"
              className={inputClass}
              required={field.required}
              value={values[field.id] || ''}
              onChange={(e) => setValue(field.id, e.target.value)}
            />
          )}

          {field.type === 'time' && (
            <input
              type="time"
              className={inputClass}
              required={field.required}
              value={values[field.id] || ''}
              onChange={(e) => setValue(field.id, e.target.value)}
            />
          )}

          {['select','dropdown'].includes(field.type) && (
            <select
              className={inputClass}
              required={field.required}
              value={values[field.id] || ''}
              onChange={(e) => setValue(field.id, e.target.value)}
            >
              <option value="">Select...</option>
              {(field.options || []).map(opt => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          )}

          {field.type === 'checkbox' && (
            <label className="flex items-center gap-2 text-sm text-zinc-300">
              <input
                type="checkbox"
                checked={!!values[field.id]}
                onChange={(e) => setValue(field.id, e.target.checked)}
              />
              Confirm
            </label>
          )}

          {field.type === 'signature' && (
            <input
              className={inputClass}
              placeholder="Type full name as signature"
              value={values[field.id] || ''}
              onChange={(e) => setValue(field.id, e.target.value)}
            />
          )}

          {['photo', 'file_upload'].includes(field.type) && (
            <input
              type="file"
              className={inputClass}
              onChange={(e) => setValue(field.id, e.target.files?.[0]?.name || '')}
            />
          )}

          {field.type === 'risk_level' && (
            <select
              className={inputClass}
              required={field.required}
              value={values[field.id] || ''}
              onChange={(e) => setValue(field.id, e.target.value)}
            >
              <option value="">Select risk...</option>
              <option value="Low">Low</option>
              <option value="Medium">Medium</option>
              <option value="High">High</option>
              <option value="Critical">Critical</option>
            </select>
          )}
        </div>
      ))}

      <button
        type="submit"
        className="rounded-lg bg-blue-600 hover:bg-blue-500 px-4 py-2 text-sm font-semibold text-white"
      >
        Submit Report
      </button>
    </form>
  );
}
